import React from "react";
import Header from "../../components/ui/Header";
import Breadcrumb from "../../components/ui/Breadcrumb";
import Icon from "../../components/AppIcon";

// Keep your existing wrappers
import ContactFormSection from "./components/ContactFormSection";
import ContactInfoSidebar from "./components/ContactInfoSidebar";

// ✅ Reuse the SAME ContactForm used on apartment/room pages
import ContactForm from "../apartment-detail-view/components/ContactForm";

const ContactInquiryForm = () => {
  // Minimal "apartment-like" context so the shared ContactForm has what it needs
  const contactContext = {
    id: "contact-page",
    title: "General Inquiry",
    capacity: 4,
    host: {
      name: "Guest House Sonja",
      phone: "+385959048811",
      email: "sonja.drglin@gmail.com",
    },
  };

  const breadcrumbItems = [
    { label: "Home", path: "/property-homepage", icon: "Home" },
    { label: "Contact", icon: "MessageCircle", isActive: true },
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />

      <main className="container mx-auto px-6 lg:px-8 py-8">
        <Breadcrumb customItems={breadcrumbItems} />

        {/* Page header (kept) */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 bg-primary rounded-full mb-4">
            <Icon name="MessageCircle" size={28} color="white" />
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-foreground">
            Contact & Inquiry
          </h1>
          <p className="text-muted-foreground mt-2">
            Send us a message about availability, pricing, or any questions.
          </p>
        </div>

        {/* Apartment-style card section with your grid inside */}
        <ContactFormSection title="Contact about this property">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left: the same shared ContactForm */}
            <div className="lg:col-span-2">
              <ContactForm apartment={contactContext} prefillDates={null} />
            </div>

            {/* Right: your existing sidebar */}
            <div className="lg:col-span-1">
              <ContactInfoSidebar
                title="Contact Details"
                phone={contactContext.host.phone}
                email={contactContext.host.email}
                hostName={contactContext.host.name}
              />
            </div>
          </div>
        </ContactFormSection>
        <p className="text-center text-xs text-muted-foreground mt-6">
          A deposit is required to confirm your reservation. Deposits are
          non-refundable.
        </p>
      </main>
    </div>
  );
};

export default ContactInquiryForm;
